import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
public loading=false;
  constructor(private authService:AuthService,public flashMessagesService: FlashMessagesService,
    public router:Router) { }

  ngOnInit() {
  }
  onSignup(form:NgForm){
    this.loading=true;
    const name=form.value.name;
    //console.log(name);
    
    const email=form.value.email;
    const password=form.value.password;
    this.authService.signupUser(name,email,password)
    .catch((err)=>{
      this.loading=false;
      this.flashMessagesService.show(err.message,{cssClass:'alert-danger',timeout:3000});
      this.router.navigate(['/signup']);
    });
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/auth/signup/signup.component.ts